import $ from 'jquery';

$( '.js-offcanvas-toggle' ).on( 'click', function( e ) {
	e.preventDefault();
	$( '.c-offcanvas' ).toggleClass( 'is-active' );
	$( 'html' ).toggleClass( 'u-overflow-hidden offcanvas-visible' );
} );

$( window ).on( 'resize', function() {
	var win = $( this );
	if ( win.width() > 992 & ( $( 'html' ).hasClass( 'offcanvas-visible' ) ) ) {
		$( 'html' ).removeClass( 'u-overflow-hidden' );
	} else if ( win.width() < 992 & ( $( 'html' ).hasClass( 'offcanvas-visible' ) ) ) {
		$( 'html' ).addClass( 'u-overflow-hidden' );
	}
});